export enum ChartItemColor {
  transparent,
  gray,
  lighterGray,
  lightGray,
  darkGray,
  blue,
  darkBlue,
  red,
  darkRed,
  redMuted,
  green,
  darkGreen,
  greenMuted,
  teal,
  purple,
  violet,
  emerald,
  orange,
  orangeLight,
  amber,
  pink,
  lime,
  yellow,
  darkYellow,
}

export type ChartItemColorType = keyof typeof ChartItemColor

export const CHART_ITEM_COLORS: Record<ChartItemColorType, string> = {
  transparent: 'text-transparent',
  gray: 'text-gray-200 dark:text-gray-700',
  lighterGray: 'text-gray-200 dark:text-gray-600',
  lightGray: 'text-gray-400',
  darkGray: 'text-gray-700 dark:text-gray-300',
  blue: 'text-blue-400',
  darkBlue: 'text-blue-500',
  red: 'text-red-400',
  darkRed: 'text-red-500',
  redMuted: 'text-red-300 dark:text-red-600',
  green: 'text-green-400',
  darkGreen: 'text-green-500',
  greenMuted: 'text-green-200 dark:text-green-500',
  teal: 'text-teal-400 dark:text-teal-300',
  purple: 'text-purple-400',
  violet: 'text-violet-400',
  emerald: 'text-emerald-400 dark:text-emerald-300',
  orange: 'text-orange-300',
  orangeLight: 'text-amber-100 dark:text-orange-500',
  amber: 'text-amber-300',
  pink: 'text-pink-400',
  lime: 'text-lime-400 dark:text-lime-300',
  yellow: 'text-yellow-300 dark:text-yellow-200',
  darkYellow: 'text-yellow-400',
}

export const CARTESIAN_STROKE = 'stroke-gray-100 dark:stroke-gray-700'
